import { NumberUtils } from '../../../common/numberUtils';
import React from 'react';
import Skeleton from 'react-loading-skeleton';
import classNames from 'classnames';
export interface SectionListProps {
  className?: string;
  title: string;
  children: React.ReactNode;
  isFetching?: boolean;
}
export default function SectionList({ className, title, children, isFetching }: SectionListProps) {
  return (
    <section className={classNames('row section-list', className)}>
      <div className="col-12 col-md-3 section-list__title">
        {isFetching ? <Skeleton width={NumberUtils.randomInteger(150, 250)} /> : <h3>{title}</h3>}
      </div>
      <div className="col-12 col-md-9">
        <ul className="section-list__list">{children}</ul>
      </div>
    </section>
  );
}
